import {
  Component,
  Input,
  ViewEncapsulation
} from '@angular/core';

/**
 * Sample component
 *
 * Usage:
 * <code><pre>
 * // Individual module import
 * import { SampleModule } from 'patternfly-ng/sample';
 * // Or
 * import { SampleModule } from 'patternfly-ng';
 *
 * &#64;NgModule({
 *   imports: [SampleModule,...]
 * })
 * export class AppModule(){}
 * </pre></code>
 */

export class SampleComponent {
  /**
   * Set to true to disable
   */
   disabled: Boolean;

  /**
   * The label
   */
   label: string;

  /**
   * The default constructor
   */
  constructor() {
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  encapsulation: ViewEncapsulation.None,
  selector: 'pf-sample-component',
  styles: [`
    .pfng__samplecomponent { 
      color: blueviolet; 
    }
    .pfng__samplecomponent--disabled  { 
      color: grey; 
    }
  `],
  template: `<div class="pfng__samplecomponent" [ngClass]="{'pfng__samplecomponent--disabled': disabled}">{{label}}</div>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'disabled': [{ type: Input },],
'label': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
